<template>
  <v-menu
    v-model="menuRef"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :nudge-right="40"
    min-width="290px"
    :disabled="disabled"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="textFieldValue"
        :label="label"
        prepend-inner-icon="alarm"
        v-on="on"
        readonly
        :disabled="disabled"
        :rules="[requiredCheck()]"
        :clearable="clearable ? clearable : false"
        @click:prepend="menuRef = true"
        outlined
        :dense="dense ? dense : false"
        :hide-details="hideDetails ? hideDetails : false"
      ></v-text-field>
    </template>
    <v-time-picker
      v-model="timePickerValue"
      ampm-in-title
    ></v-time-picker>
  </v-menu>
</template>

<script>
import { required } from '@/lib/formValidations'

export default {
  props: [
    'value',
    'label',
    'required',
    'disabled',
    'clearable',
    'dense',
    'hideDetails'
  ],
  data () {
    return {
      menuRef: false,
      timePickerValue: null
    }
  },
  computed: {
    textFieldValue () {
      if (this.timePickerValue) {
        let stringArray = this.timePickerValue.split(':')
        let hours = parseInt(stringArray[0])
        let minutes = parseInt(stringArray[1])
        let complement = hours >= 12 ? 'PM' : 'AM'
        let hoursText = ''
        if (hours === 0) {
          hoursText = '12'
        } else {
          hoursText = hours > 12 ? ((hours - 12) < 10 ? '0' + (hours - 12) : (hours - 12)) : (hours < 10 ? '0' + hours : hours)
        }
        let minutesText = minutes < 10 ? '0' + minutes : minutes
        this.$emit('valueChange', this.timePickerValue)
        return hoursText + ':' + minutesText + ' ' + complement
      }
      return null
    }
  },
  methods: {
    requiredCheck () {
      return !this.required || required(this.label)
    }
  },
  created () {
    if (this.value) {
      this.timePickerValue = this.value
    }
  }
}
</script>

<style>
.week-highlight .v-date-picker-table.v-date-picker-table--date.theme--light tbody tr:hover {
  background-color: #91baff;
}
</style>
